module.exports = __webpack_public_path__ + "static/media/Warning.adf6843a.svg";